import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useState } from 'react';
import { BaseQuestionAnswerComponent } from '../../../bases';
import { useQuestionContext } from '../../../core';
import { FillInBlankDescription } from './components';
import { jsx as _jsx } from "react/jsx-runtime";
export var FillInBlankAnswerComponent = function FillInBlankAnswerComponent(_ref) {
  var states = _ref.states,
      actions = _ref.actions;

  var _useQuestionContext = useQuestionContext(),
      question = _useQuestionContext.question;

  var answers = states.answers;
  var onChangeAnswer = actions.onChangeAnswer;

  var _useState = useState({}),
      value = _useState[0],
      setValue = _useState[1];

  var handleAnswer = function handleAnswer(uuid, val) {
    setValue(_objectSpread(_objectSpread({}, value), {}, _defineProperty({}, uuid, val)));
    onChangeAnswer === null || onChangeAnswer === void 0 ? void 0 : onChangeAnswer(uuid, val);
  };

  return /*#__PURE__*/_jsx(BaseQuestionAnswerComponent, {
    states: _objectSpread(_objectSpread({}, states), {}, {
      hasCustomDescription: true
    }),
    actions: actions,
    children: /*#__PURE__*/_jsx(FillInBlankDescription, {
      description: question.description,
      answers: answers,
      question: question,
      startQuestionIndex: question.index,
      onAnswer: handleAnswer,
      readOnly: false,
      isShowCorrectAnswer: false
    })
  });
};